import { defineSimpleButton } from "@/graphHandling/components/simpleButton/definitions/customizable";
import { CellFn } from "@/graphHandling/graphTypes";
import common from "@/i18n/definitions/common";
import { Variant } from "@/components/00-atoms/SimpleButton/Color.tsx";

export const initialize_lisaaPainike: CellFn = (storeFunctions, intl) => {
  if (!intl) {
    console.warn("Parametri intl puuttuu.");
    return false;
  }

  return defineSimpleButton(
    {
      ariaLabel: "Lisää-painike",
      icon: "FaPlus",
      id: "ulkomaa-uusi-kuvaus",
      isHidden: false,
      text: intl.formatMessage(common.lisaaUusiKuvaus),
      variant: Variant.TEXT
    },
    async (): Promise<boolean> => {
      return true;
    }
  );
};
